import { COGNITO } from './config'

const VERIFIER_KEY = 'pkce_verifier'
const ID_TOKEN_KEY  = 'id_token'

function base64url(buf: ArrayBuffer): string {
  const bytes = new Uint8Array(buf)
  let str = ''
  for (const b of bytes) str += String.fromCharCode(b)
  return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '')
}

export function getIdToken(): string | null {
  return sessionStorage.getItem(ID_TOKEN_KEY)
}

export function isAuthenticated(): boolean {
  return sessionStorage.getItem(ID_TOKEN_KEY) !== null
}

export function logout(): void {
  sessionStorage.removeItem(ID_TOKEN_KEY)
  const params = new URLSearchParams({
    client_id:  COGNITO.clientId,
    logout_uri: COGNITO.redirectUri.replace('/callback', ''),
  })
  window.location.href = `${COGNITO.domain}/logout?${params}`
}

export async function login(): Promise<void> {
  const randomBytes = new Uint8Array(48)
  crypto.getRandomValues(randomBytes)
  const verifier  = base64url(randomBytes.buffer as ArrayBuffer)
  const hashBuf   = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier))
  const challenge = base64url(hashBuf)

  sessionStorage.setItem(VERIFIER_KEY, verifier)

  const params = new URLSearchParams({
    response_type:          'code',
    client_id:              COGNITO.clientId,
    redirect_uri:           COGNITO.redirectUri,
    code_challenge:         challenge,
    code_challenge_method:  'S256',
    scope:                  COGNITO.scopes,
  })
  window.location.href = `${COGNITO.domain}/oauth2/authorize?${params}`
}

export async function handleCallback(code: string): Promise<boolean> {
  const verifier = sessionStorage.getItem(VERIFIER_KEY)
  if (!verifier) return false
  sessionStorage.removeItem(VERIFIER_KEY)

  const body = new URLSearchParams({
    grant_type:    'authorization_code',
    client_id:     COGNITO.clientId,
    redirect_uri:  COGNITO.redirectUri,
    code,
    code_verifier: verifier,
  })

  const resp = await fetch(`${COGNITO.domain}/oauth2/token`, {
    method:  'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body:    body.toString(),
  })

  if (!resp.ok) return false

  const tokens = await resp.json() as { id_token?: string }
  if (!tokens.id_token) return false

  sessionStorage.setItem(ID_TOKEN_KEY, tokens.id_token)
  return true
}
